<template>
  <div>
    <div class="upload-box">
      <van-uploader
        v-model="fileList"
        :class="mClassName"
        :max-count="maxImag"
        :accept="mold.accept"
        :preview-image="showFileList"
        :preview-size="previewSize"
        :multiple="multiple"
        :after-read="afterReader"
        @delete="handleDelete"
      >
        <van-circle
          class="upload-progress"
          size="58px"
          v-if="showProgress && localShowProgress"
          v-model="currentRate"
          :rate="0"
        />
        <slot v-else name="input"></slot>
      </van-uploader>
      <slot name="btn"></slot>
    </div>
    <div
      v-show="hasTips"
      style="white-space: nowrap; margin-top: 10px;"
      slot="tip"
      class="el-upload__tip"
    >{{mold.tips}}</div>
  </div>
</template>

<script>
import { Common } from "@/api";
import Compressor from "compressorjs";
import * as qiniu from "qiniu-js";
export default {
  name: "qiniu",
  props: {
    mClassName: {
      type: String
    },
    previewSize: {
      type: [String, Number],
      default: 60
    },
    capture: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    hasTips: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: "picture"
    },
    // 是否显示图片列表
    showFileList: {
      type: Boolean,
      default: false
    },
    // 超过这个数字上传按钮会消失
    maxImag: {
      type: Number,
      default: 599
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    showVideoImg: {
      type: Boolean,
      default: false
    },
    mold: {
      type: Object,
      default: function() {
        return {
          type: ["image/jpeg", "image/png"],
          accept: "image/*",
          tips: "只能上传 jpg/png 文件，且不超过 500kb",
          sizeError: "上传图片大小不能超过 500KB!",
          moldError: "上传图片只能为 JPG/PNG 格式!",
          isSize: function(size, max = 500) {
            return size / 1024 < max;
          }
        };
      }
    },
    accept: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      bucketHost: "https://img.51mydao.com",
      uploadForm: {
        file: null,
        key: "",
        token: "",
        putExtra: {
          fname: "",
          params: {},
          mimeType: null
        },
        config: {
          useCdnDomain: true,
          disableStatisticsReport: false,
          retryCount: 6,
          region: qiniu.region.z2
        }
      },
      currentRate: 0,
      localShowProgress: false,
      fileList: [],
      // image, video
      fileType: "image",
      getVideoImg: false
    };
  },
  created() {
    this.fileType = /image/.test(this.mold.accept) ? "image" : "video";
  },
  methods: {
    // 处理上传类型
    handleType(type) {
      return this.mold.type.some(item => {
        return item === type;
      });
    },
    handleChange(file, list) {
      if (!this.autoUpload) {
        let isVali = this.validata(file.raw);
        if (isVali) {
          this.$emit("changeList", file, list);
        } else {
          list.shift();
        }
      }
    },
    handleDelete(file) {
      this.$emit("delete", file);
    },
    validata(qfile) {
      let file = qfile.file;
      const isType = this.handleType(file.type);
      if (!isType) {
        this.$tips.error(this.mold.moldError);
        return false;
      }
      return true;
    },
    afterReader(qfile) {
      let that = this;
      let isVali = this.validata(qfile);
      if (isVali) {
        this.$emit("update:loading", true);
        if (this.fileType === "image") {
          // 图片需要压缩
          this.compressPic(qfile.file)
            .then(file => {
              qfile.file = file;
            })
            .then(() => {
              return this.getQiniuToken();
            })
            .then(resp => {
              that.uploadForm.file = qfile.file;
              that.uploadForm.key = that.initFileName(qfile.file);
              that.uploadForm.token = resp;
            })
            .then(function() {
              that.submit();
            });
        } else {
          this.getQiniuToken()
            .then(resp => {
              that.uploadForm.file = qfile.file;
              that.uploadForm.key = that.initFileName(qfile.file);
              that.uploadForm.token = resp;
            })
            .then(function() {
              that.submit()
            });
        }
        // new Compressor(qfile.file, {
        //   maxWidth: 158,
        //   success(result) {
        //     that

        //       .then(resp => {
        //         that.uploadForm.file = result;
        //         that.uploadForm.key = that.initFileName(result);
        //         that.uploadForm.token = resp;
        //       })
        //       .getQiniuToken()
        //       .then(function() {
        //         that.submit();
        //       });
        //   }
        // });
      }
    },
    compressPic(file) {
      return new Promise(rel => {
        new Compressor(file, {
          maxWidth: 330,
          success(result) {
            rel(result);
          }
        });
      }).catch(err => {
        console.log("img compress error: ", err);
      });
    },
    submit() {
      let { file, key, token, putExtra, config } = this.uploadForm;
      var observable = qiniu.upload(file, key, token, config, putExtra);
      observable.subscribe({
        next: this.handleNext,
        error: this.handleError,
        complete: this.handleSuccess
      });
    },
    getQiniuToken() {
      return this.$api(Common.GetQiNiuToken, {});
    },
    initFileName(file) {
      // let string = this.utils.randomString(8)
      let date = +new Date()
      let name = encodeURIComponent(file.name)
      name = name.replace(/%/g, '')
      return `${date}_${name}`
    },
    handleNext(data) {
      this.currentRate = Math.floor(data.total.percent);
      this.localShowProgress = true;
      if (this.currentRate == 100) {
        this.localShowProgress = false;
      }
      this.$emit("onProgress", data.total);
      // total.loaded: number，已上传大小，单位为字节。
      // total.total: number，本次上传的总量控制信息，单位为字节，注意这里的 total 跟文件大小并不一致。
      // total.percent: number，当前上传进度，范围：0～100。
    },
    handleSuccess(response) {
      this.uploadForm.file.baseUrl = this.bucketHost + "/" + response.key;
      this.$emit("input", this.uploadForm.file.baseUrl);
      this.$emit("resultUrlList", this.uploadForm.file);
      this.$emit("update:loading", false);
    },
    handleError() {
      this.$emit("update:loading", false);
      this.$emit("handleError");
    },
    // getVideoImgFunc(file) {
    //   return new Promise((rel, rej) => {
    //     const video = document.createElement("video");

    //     video.addEventListener(
    //       "loadedmetadata",
    //       function loadedmetadata() {
    //         setTimeout(() => {
    //           const canvas = document.createElement("canvas");
    //           canvas.width = this.videoWidth;
    //           canvas.height = this.videoHeight;
    //           const ctx = canvas.getContext("2d");
    //           ctx.drawImage(this, 0, 0);

    //           const image = new Image();
    //           image.src = canvas.toDataURL("image/png");
    //           image.onload(() => {});
    //         }, 300);
    //       },
    //       false
    //     );

    //     video.src = URL.createObjectURL(stream);
    //     video.play();
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.upload-progress {
  width: 60px;
}
</style>

